import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import {axiosInstance, client as http} from "@/http_client";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {user},
    state: {
        tasks: {
            totals: {},
            assigned: {},
            // Outstanding tasks left on archived trips. Kept out of totals so
            // the dashboard only counts current work; surfaced on the Archived
            // Trips nav item instead.
            archived: {},
            // Per-staff-member queues (+ the unassigned pool) for the
            // Assigned Tasks section of the Tasks card.
            byAssignee: []
        },
        assignees: [],
        // Leads awaiting follow-up (neither converted nor marked "did not
        // convert") — drives the Leads badge on the dashboard.
        leadCounts: {
            pending: 0
        }
    },
    mutations: {
        setTasks(state, payload) {
            state.tasks = payload;
        },
        setAssignees(state, assignees) {
            state.assignees = assignees;
        },
        setLeadCounts(state, payload) {
            state.leadCounts = payload;
        }
    },
    getters: {
        tasks: state => state.tasks,
        assignees: state => state.assignees,
        leadCounts: state => state.leadCounts
    },
    actions: {
        updateTasks({commit}) {
            return new Promise((resolve, reject) => {
                http.get('/api/tasks/', {force: true}).then(response => {
                    commit('setTasks', response.data);
                    resolve(response.data);
                }, err => {
                    reject(err.response.data);
                });
            });
        },
        updateLeadCounts({commit}) {
            return new Promise((resolve, reject) => {
                http.get('/api/leads/counts', {force: true}).then(response => {
                    commit('setLeadCounts', response.data);
                    resolve(response.data);
                }, err => {
                    reject(err.response.data);
                });
            });
        }
    }
});
